import React from "react";
import { formatTimeAgo } from "../../utils/utils";

const ItemListJob = (
    {
        job,
        index,
        handleViewJob,
        isPastJob = false,
        handleMarkAsComplete,
    }) => {

    const firstFile = job?.files?.[0];
    const fileCount = job?.files?.length || 0;

    // remaining files count
    const remainingCount = fileCount > 1 ? fileCount - 1 : 0;

    const formatOptions = (file) => {
        if (!file?.printOptions) return "";

        const o = file.printOptions;

        const result = [];

        // Paper size
        if (o.paperSize) result.push(o.paperSize);

        // Color
        if (o.color) {
            if (o.color === "Color") {
                result.push("Colour");
            } else if (o.color === "B/W") {
                result.push("B/W");
            }
        }

        // Double sided (convert YES → label, NO → skip)
        if (o.doubleSided === "Yes") {
            result.push("Double Sided");
        }

        // Binding (YES → Binding, NO → ignore)
        if (o.binding === "Yes") {
            result.push("Binding");
        }

        // Paper thickness (only if exists)
        if (o.paperThickness) result.push(o.paperThickness);

        // Quantity → X format
        if (o.quantity) {
            result.push(`X${o.quantity}`);
        }

        return result.join(", ");
    };

    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[20px] flex flex-col gap-[14px] hover:border-[#c0c2c6] hover:shadow-[0px_4px_20px_0px_rgba(0,0,0,0.06)] transition-all cursor-pointer group">

            {/* Header */}
            <div className="flex items-start justify-between gap-[12px]">
                <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-[15px] text-[#212326] mb-[2px] truncate">
                        {job?.customer?.name}
                    </h3>
                    <p className="text-[12px] text-[#717182] truncate">
                        {job?.customer?.email}
                    </p>
                </div>

                <span className="inline-flex items-center gap-[5px] px-[10px] py-[4px] rounded-[8px] bg-[#f4f5f6] text-[#717182] text-[11px] font-semibold shrink-0">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[12px] h-[12px]"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    {formatTimeAgo(job.createdAt)}
                </span>
            </div>

            {/* File Box */}
            <div className="bg-[#f8f8fa] rounded-[10px] p-[12px] flex flex-col gap-[8px]">
                <div className="flex items-center gap-[8px]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[16px] h-[16px] text-[#c0392b] shrink-0"
                    >
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                        <path d="M10 9H8" />
                        <path d="M16 13H8" />
                        <path d="M16 17H8" />
                    </svg>

                    <span className="text-[13px] text-[#212326] font-medium truncate">
                        {firstFile?.name || "No file"}
                    </span>

                    <span className="ml-auto font-medium text-[12px] text-[#ff5323] shrink-0">
                        {remainingCount > 0 ? `+${remainingCount} more` : "1 file"}
                    </span>
                </div>

                <p className="text-[12px] text-[#717182] pl-[24px]">
                    {formatOptions(firstFile) || "No print options selected"}
                </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-[8px] mt-auto pt-[4px]">

                {isPastJob ? (
                    <button
                        onClick={() => handleViewJob(job)}
                        className="flex-1 flex items-center justify-center gap-[6px] px-[14px] py-[9px] rounded-[10px] border border-[#e4e5e7] text-[#212326] text-[13px] font-semibold hover:bg-[#f4f5f6] transition-colors"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-[14px] h-[14px]"
                        >
                            <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        View Details
                    </button>
                ) : (
                    <>
                        <button
                            onClick={() => handleMarkAsComplete(job)}
                            className="flex-1 flex items-center justify-center px-[14px] py-[9px] rounded-[10px] border border-[#e4e5e7] text-[#212326] text-[13px] font-semibold hover:bg-[#f4f5f6] transition-colors"
                        >
                            Complete
                        </button>

                        <button
                            className="flex-1 flex items-center justify-center gap-[6px] px-[14px] py-[9px] rounded-[10px] bg-[#ff5323] text-white text-[13px] font-semibold hover:bg-[#e64a1f] transition-colors"
                            onClick={() => handleViewJob(job)}
                        >
                            View Job
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="w-[14px] h-[14px]"
                            >
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ItemListJob;